import { useWebLock } from '@core/hooks/useWebLock'

/**
 * Hook that requests a Web Lock when the app can join the visitor channel.
 * @returns A function that releases the lock
 */
export function useVisitorChannelLock(
  shouldRequestLock: boolean,
): (() => void) | undefined {
  // Requests a Web Lock when this tab is focused. If granted, this tab will
  // join the visitor topic. This lock prevents more than one tab from trying to
  // join this topic at once, because our backend does not allow that.
  const releaseTopicLock = useWebLock('visitor-channel-lock', shouldRequestLock)

  return releaseTopicLock
}
